import mod from "-!../../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/help.vue?vue&type=script&lang=js&
// module id = 194
// module chunks = 30